import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useSubmitFeedback = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onSubmitFeedbackDataError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while submitting feedback.',
        );
    };

    const onSubmitFeedbackDataSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message || 'Feedback submitted successfully');
        callbackFn();
    };

    const submitFeedback = (
        data: { feedback: string; },
        driverId: string,
        callbackFn: () => void,
    ) => {

        const url: HttpConfig = {
            url: `ba/v1/drivers/verification/complaints/${driverId}/feedback`,
            method: 'put',
            data,
        };

        request(url, onSubmitFeedbackDataSuccess(callbackFn), setLoading, onSubmitFeedbackDataError);
    };

    return { submitFeedback, loading };
};

export default useSubmitFeedback;
